import { INVENTORY_REQUEST_ASYNC_MESSAGES } from './constants';

type GraphQLErrorWithCode = { extensions?: { code?: string } };

/**
 * True when the server refused a change because a submission for the record is still in flight.
 * Reads only the error code the server sends with that refusal, never the message text.
 */
export const hasSubmissionInFlightErrorCode = (error: unknown): boolean => {
  const graphQLErrors = (error as { graphQLErrors?: GraphQLErrorWithCode[] })?.graphQLErrors;

  if (!Array.isArray(graphQLErrors)) {
    return false;
  }

  return graphQLErrors.some(
    graphQLError =>
      graphQLError?.extensions?.code ===
      INVENTORY_REQUEST_ASYNC_MESSAGES.SUBMIT_IN_FLIGHT_ERROR_CODE
  );
};
